<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs6>
          <v-btn @click="back" text class="text_btn">
            <v-icon>keyboard_arrow_left</v-icon>back
          </v-btn>
        </v-flex>
        <v-flex xs6 style="text-align:right;">
          <v-btn @click="d_edit = true" text class="text_btn">
            <v-icon>settings</v-icon>Settings
          </v-btn>
        </v-flex>
      </v-layout>
      <h1>
        {{ p_name }}
        <i
          :style="{color: published ? 'green' : 'grey', fontSize: '20px'}"
          :class="{fad: true, 'fa-check-circle': published, 'fa-drafting-compass': !published}" :title="published ? 'Published' : 'Sandbox'"
        ></i>
      </h1>
      <p class="enable_new_line" v-html="p_description" v-linkified></p>
      <v-layout row wrap>
        <v-flex sm3>
          <v-list style="background:transparent;" shaped>
            <v-list-item-group :mandatory="true" v-model="nav_project" color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <i class='fad fa-database'></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Storage</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <i class='fad fa-key'></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Authentication</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <i class='fad fa-paper-plane'></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Messaging</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <i class='fad fa-function'></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Functions</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <i class='fad fa-copy'></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Files</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <i class='fad fa-phone-laptop'></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Apps</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <i class='fad fa-ellipsis-h'></i>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>More</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-flex>
        <v-flex sm9>
          <section v-if="nav_project === 0">
            <h2>Storage</h2>
            <p>Store the user data inside of buckets and containers.</p>
            <v-layout row wrap v-if="l_buckets" class="spacer_before">
              <v-flex
                v-for="bucket in buckets"
                class="list_card_outer"
                :key="bucket.id"
                xs12
                sm6
                md4
                lg3
              >
                <Bucket
                  :id="parseInt(bucket.id)"
                  :name="bucket.name"
                  :project_id="parseInt($route.params.id)"
                  :insights="getBucketInsights(parseInt(bucket.id))"
                />
              </v-flex>
              <v-flex xs12 sm6 md4 lg3 @click="d_new_bucket = true">
                <AddCard description="New bucket" />
              </v-flex>
            </v-layout>
            <div v-if="!l_buckets">
              <Loading />
            </div>
          </section>
          <section v-if="nav_project === 1">
            <h2>Authentication</h2>
            <p>Provide a full authentication solution for your users.</p>
            <v-layout row wrap class="spacer_before">
              <v-flex xs12 sm6 md4 lg3 @click="navToUserSettings">
                <AddCard icon="group" description="Users" />
              </v-flex>
              <v-flex xs12 sm6 md4 lg3 @click="navToAuthSettings">
                <AddCard icon="settings" description="Settings" />
              </v-flex>
            </v-layout>
          </section>
          <section v-if="nav_project === 2">
            <h2>Messaging</h2>
            <p>Send data directly to the specific devices with Messages powered by Firebase Cloud Messaging.</p>
            <v-layout row wrap class="spacer_before">
              <v-flex xs12 sm6 md4 lg3 @click="navToMessagingRequests">
                <AddCard icon="cloud_upload" description="Requests" />
              </v-flex>
              <v-flex xs12 sm6 md4 lg3 @click="navToMessagingSettings">
                <AddCard icon="settings" description="Settings" />
              </v-flex>
            </v-layout>
          </section>
          <section v-if="nav_project === 3">
            <h2>Functions</h2>
            <p>Call external URLs and functions within the schmuckliCloud processes and integrate your apps with custom code.</p>
            <v-layout row wrap class="spacer_before">
              <v-flex xs12 sm6 md4 lg3 @click="navToFunctionsOverview">
                <AddCard icon="apps" description="Overview" />
              </v-flex>
            </v-layout>
          </section>
          <section v-if="nav_project === 4">
            <h2>Files</h2>
            <p>Users can upload full sized files to a storage. Manage here some of the settings to limit the storage space for example.</p>
            <v-layout row wrap class="spacer_before">
              <v-flex xs12 sm6 md4 lg3 @click="navToFilesSettings">
                <AddCard icon="settings" description="Settings" />
              </v-flex>
            </v-layout>
          </section>
          <section v-if="nav_project === 5">
            <h2>Apps</h2>
            <p>Add an app to connect the client application with the schmuckliCloud service.</p>
            <v-layout row wrap v-if="l_apps" class="spacer_before">
              <v-flex v-for="app in apps" class="list_card_outer" :key="app.id" xs12 sm6 md4 lg3>
                <App
                  :id="parseInt(app.id)"
                  :name="app.name"
                  :project_id="parseInt($route.params.id)"
                />
              </v-flex>
              <v-flex xs12 sm6 md4 lg3 @click="d_new_app = true">
                <AddCard description="New app" />
              </v-flex>
            </v-layout>
            <div v-if="!l_apps">
              <Loading />
            </div>
          </section>
          <section v-if="nav_project === 6">
            <h2>More</h2>
            <p>Checkout here more features, which are maybe useful to your project.</p>
            <v-layout row wrap class="spacer_before">
              <v-flex xs12 sm6 md4 lg3 @click="navToThirdPartyKeysSettings">
                <AddCard icon="vpn_key" description="3rd-Party Keys" />
              </v-flex>
            </v-layout>
          </section>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog for editing projects -->
    <v-dialog v-model="d_edit" width="500">
      <v-card>
        <v-form @submit="saveEdit">
          <v-card-title class="headline" primary-title>Project settings</v-card-title>

          <v-card-text>
            <v-text-field v-model="f_name" label="Name" />
            <v-textarea v-model="f_description" label="Description" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text class="text_btn" type="submit" :loading="l_edit_save">Save</v-btn>
          </v-card-actions>

          <v-divider></v-divider>

          <v-card-text>
            <h4>More information</h4>
            <v-switch
              v-model="published"
              @change="changePublishStatus"
              :label="published ? 'Published' : 'Sandbox'"
            ></v-switch>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              text
              class="text_btn"
              @click="d_delete = true"
              :disabled="published"
              type="button"
            >Delete</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog when trying to delete -->
    <v-dialog v-model="d_delete" width="500">
      <v-card>
        <v-form>
          <v-card-title class="headline" primary-title>Delete project</v-card-title>

          <v-card-text>
            <p>You are about to delete this project (with all the data like buckets and datasets). Do you really want to continue? This process cannot be undone.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text class="text_btn" @click="d_delete = false" type="button">Cancel</v-btn>
            <v-btn color="red" text class="text_btn" @click="deleteProject" type="button">Delete</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for adding buckets -->
    <v-dialog v-model="d_new_bucket" width="500">
      <v-card>
        <v-form @submit="createBucket">
          <v-card-title class="headline" primary-title>New bucket</v-card-title>

          <v-card-text>
            <v-text-field ref="new_bucket_name" v-model="f_bucket_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text class="text_btn" type="submit" :loading="l_new_bucket">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Dialog for adding apps -->
    <v-dialog v-model="d_new_app" width="500">
      <v-card>
        <v-form @submit="createApp">
          <v-card-title class="headline" primary-title>New app</v-card-title>

          <v-card-text>
            <v-text-field ref="new_app_name" v-model="f_app_name" label="Name" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text class="text_btn" type="submit" :loading="l_new_app">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { Projects } from "../logic/Projects";
import { Buckets } from "../logic/Buckets";
import { Apps } from "../logic/Apps";
import { Insights } from "../logic/Insights";

import { Notifications } from "../notification.js";

import Bucket from "../components/project/Bucket.vue";
import App from "../components/project/App.vue";

import Loading from "../components/general/Loading.vue";
import AddCard from "../components/general/AddCard.vue";

export default {
  name: "ProjectDetail",
  data() {
    return {
      //Content
      p_name: "Loading...",
      p_description: "Loading...",
      published: false,
      buckets: [],
      apps: [],
      insights: [],
      insightHeaders: [
        { text: 'Bucket', value: 'bucket_name' },
        { text: 'Container', value: 'container_name' },
        { text: 'Datasets', value: 'total_datasets' },
        { text: 'Rows', value: 'total_rows' },
        { text: 'Storage Size', value: 'total_storage_bytes' }
      ],

      nav_project:
        window.localStorage.getItem("nav_project") !== null
          ? parseInt(window.localStorage.getItem("nav_project"))
          : 0,

      //Loading states
      l_buckets: false,
      l_meta: false,
      l_edit_save: false,
      l_new_bucket: false,
      l_new_app: false,
      l_apps: false,
      l_insights: false,

      //Dialog states
      d_edit: false,
      d_delete: false,
      d_new_bucket: false,
      d_new_app: false,

      //Form states
      f_name: "",
      f_description: "",
      f_bucket_name: "",
      f_app_name: ""
    };
  },
  mounted() {
    var id = parseInt(this.$route.params.id); //Project id
    this.loadProjectMeta(id).then(function() {
      //Set default edit values for edit dialog
      this.f_name = this.p_name;
      this.f_description = this.p_description;

      this.setTitle(this.p_name);

      this.loadBuckets(id);
      this.loadApps(id);
      this.loadInsights(id);
    }.bind(this));
  },
  components: {
    Bucket,
    App,
    Loading,
    AddCard
  },
  methods: {
    async loadProjectMeta(project_id) {
      var project = await Projects.get(project_id);

      if (project.status === 200) {
        this.p_name = project.body.name;
        this.p_description = project.body.description;
        this.published = project.body.published == 1;
        this.l_meta = true;
      } else if (project.status === 404) {
        Notifications.show("Project has not been found.");
        this.$router.replace("/dashboard");
      }
    },
    async loadBuckets(project_id) {
      var buckets = await Buckets.load(project_id);
      if (buckets !== undefined) {
        this.buckets = buckets.body;
      }
      this.l_buckets = true;
    },
    async loadApps(project_id) {
      var response = await Apps.load(project_id);

      if (response.status === 200) {
        this.apps = response.body;
      } else {
        Notifications.show(response.message);
      }
      this.l_apps = true;
    },
    async loadInsights(project_id) {
      var response = await Insights.loadStorageInsights(project_id);
      if (response.status === 200) {
        this.insights = response.body;
      } else {
        Notifications.show(response.message);
      }
      this.l_insights = true;
    },
    getBucketInsights(bucket_id) {
      if (!this.l_insights) return null;
      if (!this.insights || this.insights.length === 0) return {containers: 0, datasets: 0, rows: 0, bytes: 0};
      let b_insights = this.insights.filter(i => i.bucket_id == bucket_id);
      if (b_insights.length === 0) return {containers: 0, datasets: 0, rows: 0, bytes: 0};
      let total_containers = b_insights.filter(i => i.container_id != null).length;
      let total_datasets = 0;
      let total_rows = 0;
      let total_bytes = 0;
      b_insights.forEach(i => {
          total_datasets += Number(i.total_datasets) || 0;
          total_rows += Number(i.total_rows) || 0;
          total_bytes += Number(i.total_storage_bytes) || 0;
      });
      return {
          containers: total_containers,
          datasets: total_datasets,
          rows: total_rows,
          bytes: total_bytes
      };
    },
    formatBytes(bytes) {
      if (!bytes || isNaN(bytes) || bytes == 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      let parsed = parseFloat((bytes / Math.pow(k, i)).toFixed(2));
      if (isNaN(parsed)) return '0 Bytes';
      return parsed + ' ' + sizes[i];
    },
    saveEdit(e) {
      e.preventDefault();
      var global_this = this;

      //Perform validation
      this.f_name = this.f_name.trim();
      this.f_description = this.f_description.trim();

      this.l_edit_save = true;

      var project_id = this.$route.params.id;
      Projects.edit(project_id, this.f_name, this.f_description).then(function(
        response
      ) {
        if (response.status === 200) {
          Notifications.show(response.message);
          //Move the edited values to the real variables
          global_this.p_name = global_this.f_name;
          global_this.p_description = global_this.f_description;
          global_this.d_edit = false; //Close the dialog
        } else {
          Notifications.show(response.message);
        }
        global_this.l_edit_save = false;
      });
    },
    async deleteProject() {
      var project_id = this.$route.params.id;

      var result = await Projects.delete(project_id);
      if (result.status === 200) {
        Notifications.show(result.message);
        this.$router.replace("/dashboard");
      } else {
        Notifications.show(result.message);
        this.d_delete = false;
      }
    },
    async changePublishStatus() {
      if (this.published) {
        var publish_response = await Projects.publish(
          parseInt(this.$route.params.id)
        );
        if (publish_response.status) {
          Notifications.show("The project has been published.");
        } else {
          Notifications.show(publish_response.message);
        }
      } else {
        var response = await Projects.unpublish(
          parseInt(this.$route.params.id)
        );
        if (response.status) {
          Notifications.show("The project has been unpublished.");
        } else {
          Notifications.show(response.message);
        }
      }
    },
    createBucket(e) {
      e.preventDefault();

      var global_this = this;

      var project_id = parseInt(this.$route.params.id);
      this.f_bucket_name = this.f_bucket_name.trim();

      Buckets.create(project_id, this.f_bucket_name).then(function(response) {
        if (response.status === 200) {
          Notifications.show("The bucket has been created.");
          global_this.d_new_bucket = false;
          global_this.loadBuckets(project_id);
        } else {
          Notifications.show(response.message);
        }
      });
    },
    createApp(e) {
      e.preventDefault();

      var global_this = this;

      var project_id = parseInt(this.$route.params.id);

      this.l_new_app = true;
      Apps.create(project_id, this.f_app_name).then(function(response) {
        Notifications.show(response.message);
        if (response.status === 200) {
          global_this.d_new_app = false;
          global_this.f_app_name = "";
          global_this.loadApps(project_id);
        }
        global_this.l_new_app = false;
      });
    },
    back() {
      this.$router.replace("/dashboard");
    },
    navToAuthSettings() {
      this.$router.push("/project/" + this.$route.params.id + "/auth_settings");
    },
    navToUserSettings() {
      this.$router.push("/project/" + this.$route.params.id + "/user_settings");
    },
    navToMessagingSettings() {
      this.$router.push(
        "/project/" + this.$route.params.id + "/messaging_settings"
      );
    },
    navToMessagingRequests() {
      this.$router.push(
        "/project/" + this.$route.params.id + "/messaging_requests"
      );
    },
    navToFunctionsOverview() {
      this.$router.push("/project/" + this.$route.params.id + "/functions");
    },
    navToFilesSettings() {
      this.$router.push("/project/" + this.$route.params.id + "/files/settings");
    },
    navToThirdPartyKeysSettings() {
      this.$router.push("/project/" + this.$route.params.id + "/third_party_keys");
    }
  },
  watch: {
    d_new_bucket(current) {
      var global_this = this;
      if (current) {
        setTimeout(function() {
          global_this.$refs.new_bucket_name.focus();
        }, 100);
      }
    },
    d_new_app(current) {
      var global_this = this;
      if (current) {
        setTimeout(function() {
          global_this.$refs.new_app_name.focus();
        }, 100);
      }
    },
    nav_project(val) {
      window.localStorage.setItem("nav_project", val);
    }
  }
};
</script>
